import { render, staticRenderFns } from "./selecter.vue?vue&type=template&id=5303db16&scoped=true"
import script from "./selecter.vue?vue&type=script&lang=js"
export * from "./selecter.vue?vue&type=script&lang=js"
import style0 from "./selecter.vue?vue&type=style&index=0&id=5303db16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5303db16",
  null
  
)

export default component.exports